import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { CircularProgress, Typography } from '@material-ui/core';
import { Dashboard as DashboardLayout } from 'layouts';
import EditHeadword from './EditHeadword';
import service from 'services/headwords';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

const styles = theme => ({
  progressWrapper: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  }
});

class CreateHeadword extends Component {
  signal = true;

  state = {
    isLoading: false,
    headword: null,
    headwords: {},
    error: null
  };

  async getHeadword() {
    try {
      this.setState({ isLoading: true });

      const headword = { attributes: {}};

      this.setState({ progress: 0, progressLabel: "getting keywords" });
      this.state.headwords = await service.getHeadwords();
      
      if (this.signal) {
        this.setState({
          isLoading: false,
          headword
        });
      }
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          error
        });
      }
    }
  }

  componentWillMount() {
    this.signal = true;
    this.getHeadword();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  async save() {
    try {
      if(this.state.headword.attributes.partOfSpeech=="" || this.state.headword.attributes.partOfSpeech==null || this.state.headword.attributes.partOfSpeech==undefined){
        window.alert("Please Enter a Part of Speech Option - if Legacy data please choose \"Legacy\" ")
      } else if(this.state.headword.attributes.headword=="" || this.state.headword.attributes.headword==null || this.state.headword.attributes.headword==undefined){
        window.alert("Please Enter a Keyword Value")
      } else {
        //console.log(this.state.headword.attributes.headword + "+" + this.state.headword.attributes.partOfSpeech)
        //console.log(this.state.headwords);
        //let dupeHeads = this.state.headwords.filter(hw => hw.attributes.headword === this.state.headword.attributes.headword && hw.attributes.partOfSpeech === this.state.headword.attributes.partOfSpeech);
        
        const dupeMatch = this.state.headwords.find(hw => hw.attributes.headword === this.state.headword.attributes.headword && hw.attributes.partOfSpeech === this.state.headword.attributes.partOfSpeech);
        if (!dupeMatch || (dupeMatch && window.confirm("Are you sure you want to duplicate this entry?"))) { 
          //console.log(dupeMatch);
          let user = JSON.parse(localStorage.getItem('user'));
          if(user!=null){
            this.state.headword.attributes.createdBy = user.attributes.firstName + " " + user.attributes.lastName;
          }
          this.state.headwords = await service.getHeadwords();
  
          let headword = await service.createHeadword(this.state.headword);
          this.props.history.push(`/headwords/${headword.id}`);
        }
        

      }
    } catch(err) {
      alert(`Error: ${err}`);
    }
  }

  renderTitle() {
    const { classes } = this.props;

    return (
      <div>
        <Typography className={classes.title} variant="h4">New Keyword</Typography>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    const { isLoading, headword } = this.state;
    let create=true;
    if (isLoading) {
      return (
        <DashboardLayout>
          <div className={classes.progressWrapper}>
            <CircularProgress />
          </div>
        </DashboardLayout>
      );
    }

    return (
      <DashboardLayout title={this.renderTitle()}>
        <EditHeadword create={create} headword={headword} onSave={this.save.bind(this)}/>
      </DashboardLayout>
    );
  }
}

CreateHeadword.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default compose(
  withRouter,
  withStyles(styles)
)(CreateHeadword);
